/* Rubin Extensions – The Application Edit (2026-10-21). Ohne externe Bibliotheken. */
(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.rxReady) return;
    root.dataset.rxReady = '1';

    /* Filter der Anleitungskarten */
    var filterButtons = root.querySelectorAll('[data-rx-filter]');
    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-rx-filter');
        filterButtons.forEach(function (b) { b.setAttribute('aria-pressed', String(b === button)); });
        root.querySelectorAll('[data-rx-mode]').forEach(function (card) {
          card.hidden = value !== 'all' && card.getAttribute('data-rx-mode') !== value;
        });
      });
    });

    /* Methodenfinder */
    var wear = root.querySelector('[data-rx-finder]');
    if (wear) {
      wear.addEventListener('change', function () {
        root.querySelectorAll('[data-rx-reco]').forEach(function (box) {
          box.hidden = box.getAttribute('data-rx-reco') !== wear.value;
        });
      });
    }

    /* Kategoriesuche */
    var search = root.querySelector('[data-rx-search]');
    if (search) {
      var items = root.querySelectorAll('[data-rx-title]');
      var output = root.querySelector('[data-rx-count]');
      var update = function () {
        var q = (search.value || '').toLocaleLowerCase('de-CH').trim();
        var count = 0;
        items.forEach(function (item) {
          var match = item.getAttribute('data-rx-title').indexOf(q) !== -1;
          item.hidden = !match;
          if (match) count++;
        });
        if (output) output.textContent = count ? count + ' Kategorien gefunden' : 'Keine Kategorie gefunden. Versuche einen anderen Begriff.';
      };
      search.addEventListener('input', update);
      update();
    }

    /* Lightbox für die vier Schritte */
    var dialog = root.querySelector('.rx-lightbox');
    if (dialog && typeof dialog.showModal === 'function') {
      var frame = dialog.querySelector('[data-rx-lightbox-scene]');
      var caption = dialog.querySelector('[data-rx-lightbox-caption]');
      root.querySelectorAll('[data-rx-zoom]').forEach(function (button) {
        button.addEventListener('click', function () {
          var scene = button.querySelector('.rx-scene');
          if (!scene) return;
          var copy = scene.cloneNode(true);
          var img = copy.querySelector('img');
          if (img) { img.loading = 'eager'; img.removeAttribute('fetchpriority'); }
          frame.replaceChildren(copy);
          caption.textContent = button.getAttribute('data-rx-caption') || '';
          dialog.showModal();
          document.documentElement.classList.add('rx-dialog-open');
        });
      });
      var unlock = function () { document.documentElement.classList.remove('rx-dialog-open'); };
      var closeDialog = function () { if (dialog.open) dialog.close(); unlock(); };
      dialog.querySelector('.rx-close').addEventListener('click', closeDialog);
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog();
      });
      dialog.addEventListener('cancel', unlock);
      dialog.addEventListener('close', unlock);
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') setTimeout(function () { if (!dialog.open) unlock(); }, 50);
      });
    }
  }
  function boot() { document.querySelectorAll('[data-rx-aw]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
